import { IStory } from '../validation/schema/v2/story';
import { lastMigrationVersion, migrations } from './migrations';
import { DialogLike, MigrationConfig } from './types';

const getMigratedDialog = async(dialog: DialogLike, migration: MigrationConfig, verbose: boolean = false) => {
  verbose && console.info('getMigratedDialog', { dialog, migration });

  const migratedDialog = await migration.migrationFn(dialog);

  verbose && console.info('getMigratedDialog', migration.migrationFn.toString());

  verbose && console.info('getMigratedDialog', {migratedDialog});

  // From migrationV13 and schemaV2 on-ward
  if (!migratedDialog.version && migratedDialog.metadata?.version >= 12) {
    return {
      ...migratedDialog,
      metadata: {
        ...migratedDialog.metadata,
        version: migration.version,
      }
    }
  }

  const dialogWithUpdatedVersion = {
    ...migratedDialog,
    lastVersion: undefined,
    version: migration.version.toString(),
  }

  if (dialogWithUpdatedVersion.metadata) {
    return {
      ...dialogWithUpdatedVersion,
      metadata: {
        ...dialogWithUpdatedVersion.metadata,
        version: migration.version,
      }
    }
  } else {
    return dialogWithUpdatedVersion;
  }
}

const getAvailableMigrations = (toVersion: string, currentVersion?: string, verbose: boolean = false): MigrationConfig[] => {
  if (verbose) {
    console.info('getAvailableMigrations', { toVersion, currentVersion });
  }

  const availableMigrations = [];
  const lastVersion = Number(toVersion);
  let nextVersion = currentVersion ? Number(currentVersion) + 1 : 1;
  while (nextVersion <= lastVersion) {
    availableMigrations.push({
      version: nextVersion,
      migrationFn: migrations[nextVersion]
    })
    nextVersion++;
  }

  verbose && console.info('getAvailableMigrations', {availableMigrations});

  return availableMigrations;
}

export const migrateStory = async (dialog: DialogLike, toVersion: string | number, verbose: boolean = false): Promise<IStory> => {
  verbose && console.info(`migrateDialog`, { toVersion });

  if (Number(toVersion) !== lastMigrationVersion) {
    console.warn(`Migrating dialog to a version (v${toVersion}) different than last (v${lastMigrationVersion}) available.`);
  }

  const hasMigration = migrations[toVersion];

  verbose && console.info(`migrateDialog`, { hasMigration, migrations });

  if (!hasMigration) {
    throw new Error(`Could not find migration for version: '${toVersion}'`);
  }

  if (toVersion === dialog.version) {
    verbose && console.info(`Dialog already up to date. Skip migration.`);
    return dialog;
  }

  const currentVersion = dialog.version ? dialog.version.toString() : dialog.metadata?.version?.toString();

  const availableMigrations = getAvailableMigrations(toVersion.toString(), currentVersion, verbose);

  if (availableMigrations.length === 0) {
    verbose && console.info(`No available migrations. Return same input dialog`);
    return dialog;
  }

  let finalDialog = JSON.parse(JSON.stringify(dialog));

  for (const migration of availableMigrations) {
    finalDialog = await getMigratedDialog(finalDialog, migration, verbose);
  }

  verbose && console.info('migrateDialog', {finalDialog});

  return finalDialog;
};
